<template>
  <div :id="componentId" class="sp1-carousel" :style="carouselStyle">
    <div
      class="sp1-carousel-track"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div
        v-for="(banner, idx) in banners"
        :key="idx"
        class="sp1-carousel-slide"
        :style="{ backgroundColor: banner.backgroundColor }"
      >
        <a
          v-if="banner.jumpType === 1"
          class="sp1-slide-link"
          href="javascript:;"
          @click.prevent="handleAnchor(banner.jumpContent)"
        >
          <img
            class="sp1-image_2"
            referrerpolicy="no-referrer"
            :src="banner.imageUrl"
          />
        </a>
        <a
          v-else-if="banner.jumpType === 3"
          class="sp1-slide-link"
          :href="banner.jumpContent"
          target="_blank"
        >
          <img
            class="sp1-image_2"
            referrerpolicy="no-referrer"
            :src="banner.imageUrl"
          />
        </a>
        <div
          v-else
          class="sp1-slide-static"
        >
          <img
            class="sp1-image_2"
            referrerpolicy="no-referrer"
            :src="banner.imageUrl"
          />
        </div>
      </div>
    </div>
    <div class="sp1-carousel-dots">
      <span
        v-for="(banner, idx) in banners"
        :key="idx"
        :class="['sp1-carousel-dot', { active: currentIndex === idx }]"
        @click.stop="goToSlide(idx)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroCarousel',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_2'
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      carouselWidth: 'auto',
      autoPlayInterval: 3000,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      banners: [
        {
          backgroundColor: 'rgba(245, 245, 245, 1)',
          imageUrl: require('../assets/img/banner_01.png'),
          jumpType: 1,
          jumpContent: 'module_4'
        },
        {
          backgroundColor: 'rgba(232, 244, 242, 1)',
          imageUrl: require('../assets/img/banner_01.png'),
          jumpType: 2,
          jumpContent: ''
        },
        {
          backgroundColor: 'rgba(255, 248, 240, 1)',
          imageUrl: require('../assets/img/banner_01.png'),
          jumpType: 3,
          jumpContent: 'https://www.example.com'
        }
      ]
    };
  },
  computed: {
    carouselStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px'
      };
    }
  },
  watch: {
    banners: {
      deep: true,
      handler() {
        this.updateCarouselWidth();
      }
    }
  },
  mounted() {
    this.updateCarouselWidth();
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    updateCarouselWidth() {
      const url = this.banners[0] && this.banners[0].imageUrl;
      if (!url) {
        this.carouselWidth = 'auto';
        return;
      }
      const img = new Image();
      img.onload = () => {
        this.carouselWidth = `${img.naturalWidth}px`;
      };
      img.onerror = () => {
        this.carouselWidth = 'auto';
      };
      img.src = url;
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length;
      }, this.autoPlayInterval);
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goToSlide(idx) {
      this.currentIndex = idx;
      this.stopAutoPlay();
      this.startAutoPlay();
    },
    handleAnchor(anchor) {
      if (!anchor) return;
      const el = document.getElementById(anchor);
      if (!el) return;
      const headerOffset = 86;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.sp1-carousel {
  position: relative;
  width: 2000px;
  margin-left: -300px;
  height: auto;
  overflow: hidden;
}

.sp1-carousel-track {
  display: flex;
  width: auto;
  height: auto;
  transition: transform 0.5s ease;
}

.sp1-carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  height: auto;
}

.sp1-slide-link,
.sp1-slide-static {
  display: block;
  width: 100%;
  height: auto;
}

.sp1-slide-link {
  cursor: pointer;
}

.sp1-slide-link:hover {
  opacity: 0.95;
}

.sp1-slide-static {
  cursor: default;
}

.sp1-image_2 {
  width: 2000px;
  height: auto !important;
  max-width: none !important;
  display: block;
}

.sp1-carousel-dots {
  position: absolute;
  bottom: 16px;
  left: 50%;
  z-index: 2;
  display: flex;
  gap: 8px;
  transform: translateX(-50%);
}

.sp1-carousel-dot {
  width: 22px;
  height: 6px;
  background: #D8D8D8;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.sp1-carousel-dot.active {
  background: #A00000;
}
</style>
